// Resmed brand colors

export const resmed_soft_black = "#0d0a15";
export const resmed_cool_galaxy_gray_dark = "#6e6c73";
export const resmed_cool_galaxy_gray_light = "#cfced0";
export const resmed_blissful_blue = "#006dff";
export const resmed_blissful_blue_extra_light = "#d0e8ff";
export const resmed_renewing_red = "#ffa1a1";
export const resmed_peaceful_purple_light = "#b9b9ff";

// Semantic color aliases
export const text_secondary_main = resmed_cool_galaxy_gray_dark;
